/*!

 =========================================================
 * Vue Black Dashboard PRO - v1.2.1
 =========================================================

 * Product Page: https://www.creative-tim.com/product/vue-black-dashboard-pro
 * Copyright 2019 Creative Tim (https://www.creative-tim.com)

 * Coded by Creative Tim

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */
import Vue from 'vue';
import RouterPrefetch from 'vue-router-prefetch';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import router from './routes/router';
import store from './store';
import i18n from './i18n';
import './registerServiceWorker'
import './modules/validate'
import { isDarkMode, isDarkModeMedia, preventDarkMode } from './modules/utils';
// plugin setup
Vue.use(DashboardPlugin);
Vue.use(RouterPrefetch);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store,
  i18n,
  created() {
    this.$store.dispatch('addConstants');
    this.$store.dispatch('addSurveys');
    window.addEventListener('resize', () => this.$store.commit('setWindowWidth'));

    preventDarkMode();
    window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", e => {
      const newColorScheme = e.matches ? "dark" : "light";

      preventDarkMode();
    });
  }
});
